import { render, staticRenderFns } from "./InfoPersoSection.vue?vue&type=template&id=8cbe7232"
import script from "./InfoPersoSection.vue?vue&type=script&lang=ts"
export * from "./InfoPersoSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports